import axios from "../../utils/axios";

export const getVideo = async (id) => {
    const response = await axios.get(`/videos/${id}`);

    return response.data;
};

export const updateReactions = async ({id, data}) => {
    await axios.patch(`/videos/${id}`, data);
}
